import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { errorActions } from '../../../actions';
import { RequestState } from '../../../constants/request-state';
import { helpResourcesService } from '../../../services/help-resources.service';
import { HelpResourceArticle } from '../../../types/help-resources/HelpResourceArticle';

export const useGetCategoryArticles = (categoryId?: number) => {
    const dispatch = useDispatch();

    const [articles, setArticles] = useState<HelpResourceArticle[]>([]);
    const [requestStateGetCategoryArticles, setRequestStateGetCategoryArticles] = useState(RequestState.none);

    const getData = useCallback(async (categoryId: number) => {
        try {
            setRequestStateGetCategoryArticles(RequestState.request);
            const data = await helpResourcesService.fetchCategoryArticles(categoryId);
            setArticles(data);
            setRequestStateGetCategoryArticles(RequestState.success);
        } catch (e) {
            dispatch(errorActions.unexpectedError(e));
            setRequestStateGetCategoryArticles(RequestState.failure);
        }
    }, [dispatch])

    useEffect(() => {
        if(categoryId) {
            getData(categoryId)
        }
    }, [getData, categoryId])

    return { requestStateGetCategoryArticles, articles }
}
